import type { PhaseView } from "./api";

/** What the map draws while a player hovers a phase: its objective towns and,
 * when it has one, its front line. Owner, 2026-09-22: *"För varje fas ska
 * fasobjektiv/ mål/ linjer tydligt visas på kartan när spelare hovrar över
 * fas-info."* */
export function phaseHighlight(phase: PhaseView | null | undefined): GeoJSON.FeatureCollection {
  if (!phase) return { type: "FeatureCollection", features: [] };
  const features: GeoJSON.Feature[] = phase.objectives.map((o) => ({
    type: "Feature",
    properties: { kind: "objective", label: o.mine ? `✓ ${o.name}` : o.name, mine: o.mine },
    geometry: { type: "Point", coordinates: [o.lon, o.lat] },
  }));
  if (phase.line.length >= 2) {
    features.push({
      type: "Feature",
      properties: { kind: "line" },
      geometry: { type: "LineString", coordinates: phase.line.map((p) => [p.lon, p.lat]) },
    });
  }
  return { type: "FeatureCollection", features };
}

/** How many of a phase's objectives the player holds, as the panel says it. */
export function phaseProgress(phase: PhaseView): { held: number; total: number; done: boolean } {
  const held = phase.objectives.filter((o) => o.mine).length;
  const total = phase.objectives.length;
  return { held, total, done: total > 0 && held === total };
}

/** The phase the clock is in, as the server marked it. */
export function currentPhase(phases: PhaseView[] | undefined): PhaseView | null {
  return phases?.find((p) => p.current) ?? null;
}

/** The medal a phase earned, as one glyph. Gold before the phase is half over,
 * silver by its end, bronze late — see `objectives::medal` on the server. */
export function medalIcon(medal: PhaseView["medal"] | undefined): string {
  return medal === "gold" ? "🥇" : medal === "silver" ? "🥈" : medal === "bronze" ? "🥉" : "";
}

/** Every medal so far, in phase order — the top bar's one-glance scorecard. */
export function medalStrip(phases: PhaseView[] | undefined): string {
  return (phases ?? []).map((p) => medalIcon(p.medal)).join("");
}
